import React from 'react';

import { ActionsMenuItem } from '~common/react/components/SharedWidgetsActionMenu';
import { ActionBar, ActionBarButton } from '~src/common/react/components/ActionBar';
import { IExtractTaskInfo } from '~src/ts/models/IExtractTaskInfo';
import { IPublishedConnectionDetailInfo } from '~src/ts/models/IPublishedConnectionInfo';

import { PublishedConnectionTaskActions } from './PublishedConnectionTaskActions';

function createActionButtons(
  publishedConnectionInfo: IPublishedConnectionDetailInfo,
  done: () => void
): ReadonlyArray<ActionBarButton> {
  return [
    PublishedConnectionTaskActions.createTaskAction(publishedConnectionInfo, done)
  ];
}

export type PublishedConnectionTasksActionBarProps = Readonly<{
  anyActionsAllowed: boolean;
  clearTasks: () => void;
  onUpdateTasks: () => void;
  publishedConnectionInfo: IPublishedConnectionDetailInfo;
  selectAllTasks: () => void;
  selectedTasks: ReadonlyArray<IExtractTaskInfo>;
}>;

export function PublishedConnectionTasksActionBar(props: PublishedConnectionTasksActionBarProps): JSX.Element {
  const { anyActionsAllowed, clearTasks, onUpdateTasks, publishedConnectionInfo, selectAllTasks, selectedTasks } = props;

  const actionButtons = React.useMemo(
    () => createActionButtons(publishedConnectionInfo, onUpdateTasks),
    [onUpdateTasks, publishedConnectionInfo]
  );

  const actionsMenuItems = React.useMemo(
    (): ReadonlyArray<ActionsMenuItem> => {
      return [
        selectedTasks.length === 1
          ? PublishedConnectionTaskActions.editTaskAction(selectedTasks[0], publishedConnectionInfo, onUpdateTasks)
          : PublishedConnectionTaskActions.editScheduleAction(selectedTasks, onUpdateTasks),
        PublishedConnectionTaskActions.runNowTaskAction(selectedTasks, publishedConnectionInfo, onUpdateTasks),
        PublishedConnectionTaskActions.deleteTasksAction(selectedTasks, onUpdateTasks)
      ];
    },
    [onUpdateTasks, publishedConnectionInfo, selectedTasks]
  );

  return (
    <ActionBar
      actionButtons={actionButtons}
      actionsMenuItems={actionsMenuItems}
      anyActionsAllowed={anyActionsAllowed}
      selectionSize={selectedTasks.length}
      selectAll={selectAllTasks}
      clear={clearTasks}
    />
  );
}
